// src/components/organisms/auth/auth-aside/auth-aside-content.tsx
import type { AuthAsideContent } from "./auth-aside";

// Avatars sourced from randomuser.me (allowed in next.config.ts images.remotePatterns).
export const defaultAuthAside: AuthAsideContent = {
  heading: "The infrastructure of modern commerce.",
  description:
    "Join thousands of developers and businesses using Niftipay to build the future of global payments.",
  socialProof: {
    stars: 5,
    trustLine: "Join 500+ innovators who trust Niftipay",
    avatars: [
      { src: "https://randomuser.me/api/portraits/women/44.jpg", alt: "Customer 1" },
      { src: "https://randomuser.me/api/portraits/men/32.jpg", alt: "Customer 2" },
      { src: "https://randomuser.me/api/portraits/men/76.jpg", alt: "Customer 3" },
      { src: "https://randomuser.me/api/portraits/women/68.jpg", alt: "Customer 4" },
      { src: "https://randomuser.me/api/portraits/men/52.jpg", alt: "Customer 5" },
    ],
  },
};
